import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { productSelectionStore } from "src/store/atoms";
import { toastHandler } from "src/util";

import { getProductSamplesRequest } from "./getProductSamplesRequest";

export const deleteProductSampleRequest = reatomAsync(
  async (ctx, selectionId: number) => {
    return API.productSamplesApi
      .productSelectionControllerDeleteSelection(
        { selectionId },
        {
          signal: ctx.controller.signal,
        },
      )
      .then((response) => {
        const currentSelected = ctx.get(
          productSelectionStore.currentSelectionAtom,
        );

        if (currentSelected?.id === selectionId) {
          productSelectionStore.clearSelectionAction(ctx);
        }

        toastHandler.success({
          name: "deleteProductSample",
          title: "Удаление выборки",
          content: `Удалена выборка: ${selectionId}`,
        });
        return response;
      });
  },
  {
    name: "deleteProductSampleRequest",
    onFulfill: (ctx) => {
      getProductSamplesRequest(ctx);
    },
  },
);
